module.exports = "<nav class=\"nav-tabs\">\n    <ul>\n        <li>\n            <a ui-sref=\"services.activations\" ui-sref-active=\"active\" ui-sref-active-eq class=\"icon-switch\">\n                {{'services.activations.title' | translate}}\n            </a>\n        </li>\n    </ul>\n</nav>\n\n<div class=\"nav-tabs-contents\">\n    <div class=\"page-content\" ui-view></div>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/services/services.html
 ** module id = 490
 ** module chunks = 0
 **/